import '../styles/assets.css';
import { DELETE_IMAGES, GET_IMAGES_COLLECTION, UPLOAD_IMAGES } from "@/store/images/actions";
export default {
  props: {
    assetsSlug: {
      type: String,
      required: true
    },
    assetsOwnerId: {
      type: Number,
      required: true
    }
  },
  methods: {
    async initAssets(editor) {
      const itemToAsset = (item) => ({
        id: item.id,
        src: item.full_path,
        name: item.file_name
      });
      editor.on('asset:open', async () => {
        const collection = await this.loadAssets();
        editor.AssetManager.add(collection.map(item => itemToAsset(item)));
      });
      editor.on('asset:upload:end', async ({ data }) => {
        const fetched = await fetch(data[0].src);
        const blob = await fetched.blob();
        const file = new File([blob], data[0].name, { type: blob.type });
        const item = await this.uploadAsset(file);
        const asset = editor.AssetManager.get(data[0].src);
        asset.set('id', item.id);
        asset.set('src', item.full_path);
        asset.set('name', item.file_name);
      });
      editor.on('asset:remove', async ({ attributes }) => {
        await this.deleteAsset(attributes.id);
      });
    },
    async deleteAsset(id) {
      await this.$store.dispatch(DELETE_IMAGES, {
        slug: this.assetsSlug,
        ownerId: this.assetsOwnerId,
        imageId: id
      });
    },
    async uploadAsset(file) {
      const { data } = await this.$store.dispatch(UPLOAD_IMAGES, {
        slug: this.assetsSlug,
        ownerId: this.assetsOwnerId,
        data: { file }
      });
      return data;
    },
    async loadAssets() {
      const { collection } = await this.$store.dispatch(GET_IMAGES_COLLECTION, {
        slug: this.assetsSlug,
        ownerId: this.assetsOwnerId
      });
      return collection;
    },
  }
}
